/* ==========================================================
   CRO - ventana de talla y cantidad (cross-sell del carrito + home).
   set. 2026

   QUE HACE:
   Abre una ventana con la ficha reducida -imagen, precio, selector de
   talla y color, cantidad y boton de agregar- sin sacar al cliente de
   donde esta. Funciona en celular y en escritorio.

   DONDE SE ACTIVA (ver ORIGEN):
   1. Las tarjetas de "Tambien te puede gustar" del cajon del carrito.
      Salir del carrito para elegir una talla es caro: se pierde el
      carrito de vista.
   2. La ficha entera de la rejilla del home: la foto Y el boton
      "Ver tallas y comprar".
      Al principio solo se engancho el boton, con la idea de que la foto
      fuera "descubrir" y el boton "ya decidi". Se midio y no se sostiene:
      en celular la foto ocupa 142 785 px2 y el boton 17 575, o sea la
      foto es 8.1 veces mas grande y se lleva el 89% de la superficie
      tocable. Dejarla navegando significaba que casi todos los toques
      seguian pagando el precio que la ventana venia a quitar. Ademas,
      desde la tarjeta el visitante no distingue dos promesas: toca la
      tarjeta y espera una sola cosa.
      Nada se pierde: la ventana lleva al pie "Ver todos los detalles",
      que es la puerta a la ficha completa.
      El precio de navegar, medido: la rejilla movil es un carrusel
      horizontal y al volver de la ficha el navegador rehace la pagina,
      asi que se pierden las DOS posiciones -vuelve a scrollY 0 y a la
      primera tarjeta-.

   POR QUE NO SE USA LA COMPRA RAPIDA DEL TEMA:
   Se probo y se descarto por dos motivos.
   1. Es un ajuste GLOBAL (settings.quickbuy_style). Encenderla ponia un
      boton "Vistazo rapido" tambien en colecciones, home y busqueda.
   2. Aunque se encienda, su manejador solo intercepta el clic si
      window.innerWidth >= 768. Por debajo navega a la ficha, y en esta
      tienda el celular es el 80% del trafico.
   Por eso el ajuste quedo en 'off' y esto se maneja aca.

   COMO:
   Se reusa la maquinaria del tema: descargar la ficha completa, extraer el
   nodo .quickbuy-content y aplicarle una lista de limpiezas.
   Comprobado: .quickbuy-content se renderiza aunque quickbuy_style este
   en 'off'.

   LA LISTA DE LIMPIEZAS ES CRITICA Y VA COMPLETA.
   En una version anterior se copio solo la mitad y el resultado fue una
   ventana con la galeria en blanco: faltaban las tres ultimas piezas.
     - cambiar el layout de la galeria a media-gallery--layout-carousel-under
       (la ficha usa collage-2, que dentro de una ventana angosta no dibuja)
     - quitar mobile-only de la galeria y de las miniaturas
     - COPIAR AL <head> las hojas de estilo y los scripts de la seccion que
       no esten ya cargados; sin eso la galeria queda sin estilos
   Origen: bloque .quickbuy-toggle de main.js. SI EL TEMA SE ACTUALIZA,
   comparar esa lista con la de aca.

   Los elementos personalizados del tema (variant-picker, buy-buttons,
   product-form, quantity-wrapper) se activan solos al insertarse en el DOM.
   Los <script> en linea NO: ver revivirEntrega().

   OJO: desde el carrito la ventana se abre DENTRO del cajon, asi que
   tiene que quedar por encima. De ahi el z-index alto.
   ========================================================== */

(function () {
  var ORIGEN = '.cart-item-upsells, .gs-ficha';
  var LAYOUTS_GALERIA = [
    'media-gallery--layout-carousel-beside',
    'media-gallery--layout-columns-1',
    'media-gallery--layout-columns-2',
    'media-gallery--layout-collage-1',
    'media-gallery--layout-collage-2'
  ];

  var raiz = null;
  var caja = null;
  var ultimoFoco = null;

  // POR QUE HAY CACHE Y ADELANTO
  // Medido en celular: la ficha pesa 81KB comprimidos y tarda ~1000ms en
  // llegar (392 de espera del servidor + 569 de descarga). El analisis del
  // HTML son 9ms: el problema es la red, no el navegador. No se puede pedir
  // menos -el id de seccion para pedir solo el trozo cambia de un producto
  // a otro, asi que no se puede adivinar-, pero si se puede pedirlo ANTES y
  // no pedirlo dos veces:
  //   - adelantar(): al pasar el mouse o al apoyar el dedo, no al soltar.
  //   - guardadas: la segunda vez que se abre el mismo diseño es inmediata.
  var guardadas = new Map();
  // Numero de turno en vez de AbortController: si se aborta el pedido, lo
  // descargado se tira y al reabrir hay que empezar de cero. Asi el pedido
  // sigue y llena la cache; lo unico que se descarta es pintar un resultado
  // que ya no corresponde a lo que el visitante esta mirando.
  var turno = 0;

  function traer(url) {
    if (!guardadas.has(url)) {
      guardadas.set(url, fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).catch(function (e) {
        // Un error no se guarda: el proximo intento vuelve a pedirlo.
        guardadas.delete(url);
        throw e;
      }));
    }
    return guardadas.get(url);
  }

  // LA GUIA DE TALLAS MANDA MIENTRAS ESTE ABIERTA
  // La guia se abre DENTRO de la ventana y trae su propio boton de cerrar
  // en la misma esquina que el nuestro. Medido a 375px de ancho: la X de
  // la guia ocupa 305-349 x 26-70 y la de la ventana 325-365 x 75-115.
  // Cinco pixeles entre las dos, y la yema de un dedo mide 9-11mm -34 a
  // 42px-: caben las dos en la misma huella. El error no sale gratis: una
  // cierra una ayuda y la otra abandona el producto y devuelve al home.
  // Lo mismo con Escape, que cerraba las DOS capas de un golpe: se
  // comprobo, una sola tecla dejaba al visitante en el home.
  // Regla: cerrar cierra la capa de ARRIBA. Si hay guia abierta, se cierra
  // la guia y la ventana se queda con su producto.
  // gs-quickview.css pone el otro freno: mientras la guia este abierta, la
  // X de la ventana se oculta, para que no haya dos equis que apuntar.
  function cerrarGuia() {
    if (!caja) return false;
    var guia = caja.querySelector('modal-dialog[open]');
    if (!guia) return false;
    if (typeof guia.close === 'function') {
      guia.close();
    } else {
      guia.removeAttribute('open');
    }
    return true;
  }

  function crear() {
    if (raiz) return;
    raiz = document.createElement('div');
    raiz.className = 'gs-qv';
    raiz.setAttribute('role', 'dialog');
    raiz.setAttribute('aria-modal', 'true');
    raiz.setAttribute('aria-label', 'Elegir talla y cantidad');
    raiz.hidden = true;
    raiz.innerHTML =
      '<div class="gs-qv__fondo" data-cerrar></div>' +
      '<div class="gs-qv__ventana">' +
        '<button type="button" class="gs-qv__cerrar" data-cerrar aria-label="Cerrar">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<div class="gs-qv__cuerpo"></div>' +
      '</div>';
    document.body.appendChild(raiz);
    caja = raiz.querySelector('.gs-qv__cuerpo');

    raiz.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cerrar]')) return;
      e.preventDefault();
      if (cerrarGuia()) return;
      cerrar();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !raiz || raiz.hidden) return;
      if (cerrarGuia()) return;
      cerrar();
    });
    // Una sola vez aca y no en cada carga: caja vive entre aperturas y se
    // acumularian escuchas.
    caja.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-picker')) return;
      mostrarBoton();
    });
  }

  // AL CAMBIAR DE TALLA, LA VENTANA AVANZA HASTA EL BOTON
  // Pedido de anderson. Medido en el Predator: con las barras de Safari a
  // la vista (390x664) "Anadir al carrito" queda 112px por debajo de lo
  // visible; a 375x812, 26px. Se ve la talla pero no el paso siguiente.
  // Reglas:
  // - Solo con 'change' del selector de talla, o sea cuando el visitante
  //   la cambia. Al abrir no se mueve nada: la S ya viene marcada.
  // - Avanza lo JUSTO para que el boton entre con 16px de aire, no hasta
  //   el fondo. Las tallas siguen a la vista, por si quiere cambiar otra
  //   vez. Si el boton ya se ve, no se mueve.
  // - Dos fotogramas de espera: el tema reescribe precio y boton al cambiar
  //   de variante, y hay que medir despues.
  // - Sin animacion si el celular pide reducir movimiento.
  function mostrarBoton() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!raiz || raiz.hidden) return;
        var boton = caja.querySelector('.quickbuy-content button[name="add"]');
        if (!boton || !boton.offsetParent) return;
        var falta = boton.getBoundingClientRect().bottom - caja.getBoundingClientRect().bottom + 16;
        if (falta <= 0) return;
        var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        caja.scrollBy({ top: falta, behavior: quieto ? 'auto' : 'smooth' });
      });
    });
  }

  // Recibe el elemento que la abrio. No vale document.activeElement:
  // al tocar un enlace en el celular el navegador no siempre le da el
  // foco, asi que quedaba en <body> y al cerrar el foco caia al principio
  // de la pagina -en el carrusel del home eso manda al visitante lejos de
  // la tarjeta que estaba mirando-.
  function abrir(origen) {
    crear();
    ultimoFoco = origen || document.activeElement;
    raiz.hidden = false;
    document.documentElement.classList.add('gs-qv-abierta');
    esperar(origen);
  }

  // Mientras llega la ficha se muestra la foto que el visitante acaba de
  // tocar. Ya esta descargada y decodificada, asi que aparece en el mismo
  // fotograma: la ventana deja de ser un rectangulo vacio durante un
  // segundo y el visitante ve que abrio LO QUE toco. El segundo de red
  // sigue estando; lo que cambia es que ya no se mira en blanco.
  function esperar(origen) {
    caja.innerHTML = '';
    var tarjeta = origen && origen.closest ? origen.closest(ORIGEN) : null;
    var foto = tarjeta ? tarjeta.querySelector('img') : null;
    if (foto && (foto.currentSrc || foto.src)) {
      var previa = document.createElement('div');
      previa.className = 'gs-qv__previa';
      var copia = document.createElement('img');
      copia.src = foto.currentSrc || foto.src;
      copia.alt = '';
      previa.appendChild(copia);
      caja.appendChild(previa);
    }
    var cargando = document.createElement('div');
    cargando.className = 'gs-qv__cargando';
    cargando.innerHTML = '<div class="loading-spinner"></div>';
    caja.appendChild(cargando);
  }

  function cerrar() {
    if (!raiz || raiz.hidden) return;
    turno++;
    raiz.hidden = true;
    caja.innerHTML = '';
    document.documentElement.classList.remove('gs-qv-abierta');
    // preventScroll obligatorio: sin el, devolver el foco al boton
    // "Ver tallas y comprar" -que esta al pie de la tarjeta- arrastra la
    // pagina 621px hacia abajo al cerrar. Medido en el home a 393px.
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
  }

  // Trae al <head> las hojas de estilo y los scripts que la seccion de
  // producto necesita y que esta pagina puede no tener cargados.
  function traerRecursos(tmpl) {
    tmpl.content.querySelectorAll('.section-main-product link[rel="stylesheet"]').forEach(function (el) {
      var href = el.getAttribute('href');
      if (!href) return;
      if (!document.querySelector('link[rel="stylesheet"][href="' + href + '"]')) {
        document.head.insertAdjacentHTML('beforeend', el.outerHTML);
      }
    });
    tmpl.content.querySelectorAll('.section-main-product script[src]').forEach(function (el) {
      var src = el.getAttribute('src');
      if (!src) return;
      if (!document.querySelector('script[src="' + src + '"]')) {
        var s = document.createElement('script');
        s.src = src;
        s.defer = 'defer';
        document.head.appendChild(s);
      }
    });
  }

  // Misma lista, mismo orden, que el bloque .quickbuy-toggle de main.js.
  function limpiar(nodo, url) {
    // ---- SIN ESTA LINEA LA VENTANA PIERDE EL DISENO DE LA FICHA ----
    // custom-manya.css escribe TODO el diseno propio del producto bajo el
    // prefijo .section-main-product: el precio (.price__current de 23px,
    // .price__was-label "Antes", el chip rojo .price__off), la fila de
    // cantidad, la caja de stock y los estados del boton de agregar.
    // .quickbuy-content vive DENTRO de esa seccion en la ficha, pero al
    // clonarlo aca queda colgado del <body> y todas esas reglas dejan de
    // aplicar. Sintoma: el precio salia pegado y sin jerarquia
    // -"S/. 30.00Antes S/. 35.00-14%"- porque solo sobrevivia el
    // margin-left:8px de main.css.
    // Es seguro ponerla: main.css no tiene NI UNA regla sobre
    // .section-main-product, solo la usa como prefijo de otras. El unico
    // script que la busca en el DOM es sticky-atc.js, y su elemento se
    // elimina al final de esta misma funcion.
    nodo.classList.add('section-main-product');

    nodo.querySelectorAll('.more').forEach(function (el) { el.href = url; });
    nodo.querySelectorAll('.show-gallery').forEach(function (el) {
      el.classList.remove('show-gallery'); el.href = url;
    });
    nodo.querySelectorAll('.not-in-quickbuy').forEach(function (el) { el.remove(); });
    nodo.querySelectorAll('.only-in-quickbuy').forEach(function (el) {
      el.classList.remove('only-in-quickbuy');
    });
    nodo.querySelectorAll('.sticky-content-container').forEach(function (el) {
      el.classList.remove('sticky-content-container');
    });
    nodo.querySelectorAll('pickup-availability').forEach(function (el) { el.remove(); });
    // Sin esto el selector de talla reescribe la URL del navegador estando
    // en una ventana, y el boton Atras del celular deja de volver donde debe.
    nodo.querySelectorAll('variant-picker[data-update-url="true"]').forEach(function (el) {
      el.dataset.updateUrl = false;
    });
    nodo.querySelectorAll('noscript').forEach(function (el) { el.remove(); });
    nodo.querySelectorAll('.media-gallery .main-image carousel-slider').forEach(function (el) {
      el.classList.remove('mobile-only');
    });
    nodo.querySelectorAll('.product-media-collage').forEach(function (el) { el.remove(); });
    nodo.querySelectorAll('.media-gallery .thumbnails').forEach(function (el) {
      el.classList.remove('mobile-only');
    });
    // ESTA ES LA PIEZA QUE FALTABA Y DEJABA LA GALERIA EN BLANCO.
    LAYOUTS_GALERIA.forEach(function (cl) {
      nodo.querySelectorAll('.' + cl).forEach(function (el) {
        el.classList.remove(cl);
        el.classList.add('media-gallery--layout-carousel-under');
      });
    });
    // La barra sticky de compra no tiene sentido dentro de una ventana.
    nodo.querySelectorAll('sticky-atc').forEach(function (el) { el.remove(); });
    return nodo;
  }

  // LA CAJA DE ENTREGA
  // Llega al clon con su estructura pero VACIA: la clase de estado
  // (gdlv--today / --tomorrow / --monday), el titular y las tres fechas las
  // escribe un <script> en linea de la ficha, y un <script> clonado NO se
  // ejecuta nunca -asi funciona cloneNode-. Por eso hay que volver a
  // crearlo. Se reviven SOLO los guiones que mencionan gdlv-box: revivir
  // los trece del clon volveria a registrar observadores y manejadores del
  // tema por duplicado.
  // Hay que llamarla DESPUES de insertar el clon en el documento, porque
  // esos guiones buscan la caja con getElementById.
  function revivirEntrega(contenedor) {
    var cajaEntrega = contenedor.querySelector('#gdlv-box');
    if (!cajaEntrega) return;

    // Si la pagina de atras ya tiene su propia caja -la ventana abierta
    // desde el carrito estando en una ficha-, hay dos ids iguales y
    // getElementById devuelve la de la pagina. Los guiones escribirian las
    // fechas de ESTE producto sobre la caja de AQUEL. Mejor quitarla que
    // corromper la de atras.
    if (document.getElementById('gdlv-box') !== cajaEntrega) {
      cajaEntrega.remove();
      return;
    }

    contenedor.querySelectorAll('script:not([src])').forEach(function (viejo) {
      if (viejo.textContent.indexOf('gdlv-box') === -1) return;
      var nuevo = document.createElement('script');
      nuevo.textContent = viejo.textContent;
      viejo.parentNode.replaceChild(nuevo, viejo);
    });

    // Sin clase de estado la caja no tiene color ni titular: se veria a
    // medias. Si algo fallo, mejor no mostrarla.
    if (cajaEntrega.className.indexOf('gdlv--') === -1) cajaEntrega.remove();
  }

  // EL CONTADOR "1 / 6"
  // En celular la ventana esconde las miniaturas -costarian una fila entera
  // y bajarian la talla- y las flechas del carrusel son desktop-only. Asi
  // quedaba un carrusel de 6 fotos sin una sola pista de que se desliza:
  // medido en el Predator, nadie podia saber que habia 5 fotos mas.
  // Van dos pistas. gs-quickview.css deja asomar la foto siguiente por la
  // derecha: el borde cortado dice "esto se desliza". Este contador dice
  // "cuantas son", sin ocupar alto.
  // aria-hidden porque cada diapositiva ya se anuncia "1 de 6".
  function ponerContador(contenedor) {
    var galeria = contenedor.querySelector('.media-gallery');
    var carrusel = galeria ? galeria.querySelector('.main-image carousel-slider') : null;
    if (!carrusel) return;
    var total = Array.prototype.filter.call(
      carrusel.querySelectorAll('.slider__item'),
      function (el) { return el.offsetWidth > 0; }
    ).length;
    if (total < 2) return;
    var marca = document.createElement('span');
    marca.className = 'gs-qv__contador';
    marca.setAttribute('aria-hidden', 'true');
    marca.textContent = '1 / ' + total;
    galeria.appendChild(marca);
    // El tema avisa cada cambio de foto con este evento y su detail.index,
    // tambien cuando se desliza con el dedo. Comprobado de la 1 a la 6.
    carrusel.addEventListener('on:carousel-slider:select', function (e) {
      var i = e.detail && typeof e.detail.index === 'number' ? e.detail.index : 0;
      marca.textContent = (i + 1) + ' / ' + total;
    });
  }

  function cargar(url) {
    var mio = ++turno;
    traer(url)
      .then(function (html) {
        // Llego tarde: el visitante cerro la ventana o abrio otro diseño.
        // El texto ya quedo guardado, asi que no se perdio nada.
        if (mio !== turno || !raiz || raiz.hidden) return;
        var tmpl = document.createElement('template');
        tmpl.innerHTML = html;
        var contenido = tmpl.content.querySelector('.quickbuy-content');
        if (!contenido) { window.location.href = url; return; }
        traerRecursos(tmpl);
        caja.innerHTML = '';
        caja.appendChild(limpiar(contenido.cloneNode(true), url));
        revivirEntrega(caja);
        ponerContador(caja);
        var mas = document.createElement('a');
        mas.className = 'gs-qv__mas';
        mas.href = url;
        mas.textContent = 'Ver todos los detalles';
        caja.appendChild(mas);
        caja.scrollTop = 0;
        var f = caja.querySelector('a, button, input, select');
        if (f) f.focus({ preventScroll: true });
      })
      .catch(function () {
        if (mio !== turno || !raiz || raiz.hidden) return;
        // Si algo falla, el destino natural del enlace sigue siendo valido.
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (evt) {
    // Los clics con modificador o con otro boton del raton son del
    // navegador, no nuestros: abrir en pestaña nueva, en ventana nueva,
    // guardar el enlace. Si los interceptaramos, en escritorio se perderia
    // poder abrir un diseño aparte sin salir de la rejilla.
    if (evt.defaultPrevented) return;
    if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
    var zona = evt.target.closest(ORIGEN);
    if (!zona) return;
    var enlace = evt.target.closest('a[href]');
    if (!enlace) return;
    var url = enlace.getAttribute('href') || '';
    if (url.indexOf('/products/') === -1) return;
    evt.preventDefault();
    evt.stopPropagation();
    abrir(enlace);
    cargar(enlace.href);
  }, true);

  // Empezar a traer la ficha con la INTENCION, no con el clic. En
  // escritorio el mouse se posa cientos de milisegundos antes de hacer
  // clic; en celular, el dedo se apoya ~100ms antes de soltar. Todo eso se
  // le descuenta a la espera. Si el visitante no llega a tocar, lo unico
  // que se gasto son 81KB que ademas quedan servidos por si vuelve.
  function adelantar(evt) {
    var destino = evt.target;
    if (!destino || !destino.closest) return;
    if (!destino.closest(ORIGEN)) return;
    var enlace = destino.closest('a[href]');
    if (!enlace) return;
    var url = enlace.getAttribute('href') || '';
    if (url.indexOf('/products/') === -1) return;
    traer(enlace.href).catch(function () {});
  }

  document.addEventListener('pointerover', adelantar, { capture: true, passive: true });
  document.addEventListener('touchstart', adelantar, { capture: true, passive: true });

  // Al agregar al carrito desde la ventana, cerrarla para que se vea el
  // carrito actualizado. El tema emite estos eventos al terminar.
  document.addEventListener('on:cart:add', function () { cerrar(); });
  document.addEventListener('on:line-item:change', function () { cerrar(); });
})();